<i18n lang="yaml">
zh:
  my_submissions: "我的投稿"
  search_by_id: "按ID查询"
  search_by_title: "按名称查询"
  all: "全部"
  first_review_passed: "初审通过需精修"
  review_passed: "审核通过"
  info_not_passed: "信息未通过"
  work_id: "作品ID"
  work_title: "作品名称"
  work_type: "作品类型"
  category: "分类"
  word_count: "字数"
  submission_time: "投稿时间"
  submission_status: "投稿状态"
  actions: "操作"
  revoke_submission: "撤回投稿"
  edit: "前往修改"
  view_feedback: "查看反馈"
  edit_sign_info: "修改签约信息"
  fill_sign_info: "填写签约信息"
  resubmit: "重新投稿"
  create_new_sign_info: "创建新的签约信息"
  next_step: "下一步"
  no_submissions: "还没投稿作品，完成后去预览页面投稿吧！"
  select_sign_info: "选择签约信息"
  feedback: "查看反馈"
  editor: "编辑狸狸："
  review_approved: "审核通过"
  submit_success: "提交成功"
  revoke_success: "撤回投稿成功"
  resubmit_success: "再次投稿成功"
  please_select_sign_info: "请选择签约信息"
  delete_success: "删除成功"
  confirm_revoke: "确定撤回投稿吗？"
  tip: "提示"
  confirm: "确定"
  cancel: "取消"
  confirm_delete: "确定删除投稿吗？"
en:
  my_submissions: "My Submissions"
  search_by_id: "Search by ID"
  search_by_title: "Search by Title"
  all: "All"
  first_review_passed: "First Review Passed, Needs Revision"
  review_passed: "Review Passed"
  info_not_passed: "Info Not Passed"
  work_id: "Work ID"
  work_title: "Work Title"
  work_type: "Work Type"
  category: "Category"
  word_count: "Word Count"
  submission_time: "Submission Time"
  submission_status: "Submission Status"
  actions: "Actions"
  revoke_submission: "Revoke Submission"
  edit: "Edit"
  view_feedback: "View Feedback"
  edit_sign_info: "Edit Sign Info"
  fill_sign_info: "Fill Sign Info"
  resubmit: "Resubmit"
  create_new_sign_info: "Create New Sign Info"
  next_step: "Next Step"
  no_submissions: "No submissions yet. Go to the preview page to submit your work!"
  select_sign_info: "Select Sign Info"
  feedback: "Feedback"
  editor: "Editor:"
  review_approved: "Review Approved"
  submit_success: "Submitted Successfully"
  revoke_success: "Submission Revoked Successfully"
  resubmit_success: "Resubmitted Successfully"
  please_select_sign_info: "Please select sign info"
  delete_success: "Deleted Successfully"
  confirm_revoke: "Are you sure to revoke the submission?"
  tip: "Tip"
  confirm: "Confirm"
  cancel: "Cancel"
  confirm_delete: "Are you sure to delete the submission?"
</i18n>
<template>
  <div style="padding: 1rem 1rem;position: relative;transform: translate(0);">
    <div style="font-weight: 400;color: rgba(0,0,0,0.8);margin-bottom: 20px;" class="d-flex flex-y-center flex-between">
      <div class="d-flex flex-y-center pointer" style="padding: 0.3rem 0.3rem 0 0;" @click="goHome()">
        <img src="@/assets/icon-home.png" width="40" height="40" alt="">
        <span style="margin-left: 10px;color: rgba(0,0,0,0.8);font-weight: 600;font-size: 20px;">{{ $t('my_submissions') }}</span>
      </div>
    </div>

    <div class="hidden-xs-only" style="position: absolute;top: 0;right: 0;z-index: -1;">
      <img src="@/assets/submissions-background-cover.png" style="width: 200px;">
    </div>

    <!-- 筛选条件 -->
    <div class="d-flex flex-y-center">
      <span style="display: inline-block;margin-right: 12px;">
        <el-input v-model="queryForm.id" type="number" suffix-icon="el-icon-search" class="search-title custom-select" :placeholder="$t('search_by_id')" clearable @input="fetchList()" />
      </span>
      <span style="display: inline-block;margin-right: 12px;">
        <el-input v-model="queryForm.title" suffix-icon="el-icon-search" class="search-title custom-select" :placeholder="$t('search_by_title')" clearable @input="fetchList()" />
      </span>
      <el-button class="hidden-xs-only" style="margin: 0;margin-right: 12px;" type="default" size="mini" :class="{'button-active': queryForm.articleEventType === ''}" @click="fetchListByState('')">{{ $t('all') }}（{{ tableStat.ALL || '-' }}）</el-button>
      <el-button class="hidden-xs-only" style="margin: 0;margin-right: 12px;" type="default" size="mini" :class="{'button-active': queryForm.articleEventType === 'CONTENT_OK_EDIT'}" @click="fetchListByState('CONTENT_OK_EDIT')">{{ $t('first_review_passed') }}（{{ tableStat.CONTENT_OK_EDIT || '-' }}）</el-button>
      <el-button class="hidden-xs-only" style="margin: 0;margin-right: 12px;" type="default" size="mini" :class="{'button-active': queryForm.articleEventType === 'CONTENT_OK'}" @click="fetchListByState('CONTENT_OK')">{{ $t('review_passed') }}（{{ tableStat.CONTENT_OK || '-' }}）</el-button>
      <el-button class="hidden-xs-only" style="margin: 0;margin-right: 12px;" type="default" size="mini" :class="{'button-active': queryForm.articleEventType === 'SIGN_INFO_AUDIT_NO'}" @click="fetchListByState('SIGN_INFO_AUDIT_NO')">{{ $t('info_not_passed') }}（{{ tableStat.SIGN_INFO_AUDIT_NO || '-' }}）</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      ref="tableContainer"
      :row-style="{height:'40px', lineHeight: '40px', cursor: 'pointer'}"
      :cell-style="{padding:'14px 0px', borderTop: '1px solid #f8f8f8'}"
      :header-cell-style="{color:'rgba(0,0,0,0.4)','font-weight': 400, 'font-size': '14px', padding: '0 16px'}"
      :data="tableData"
      :highlight-current-row="false"
      class="table-container"
      style="margin-top: 1rem;"
    >
      <el-table-column
        align="center"
        prop="id"
        :label="$t('work_id')"
        min-width="150px"
      />

      <el-table-column
        align="left"
        prop="title"
        :label="$t('work_title')"
        class="max-width-column"
        show-overflow-tooltip
      />

      <el-table-column
        align="center"
        prop="articleGenTypeLabel"
        :label="$t('work_type')"
      />

      <el-table-column
        align="center"
        prop="articleTypeLabel"
        :label="$t('category')"
      >
        <template slot-scope="scope">
          {{scope.row.articleTypeVo?scope.row.articleTypeVo.fieldLabel:''}}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="wordNumber"
        :label="$t('word_count')"
      />

      <el-table-column
        align="center"
        prop="deliveryTime"
        :label="$t('submission_time')"
      />

      <el-table-column
        align="center"
        prop="articleEventTypeLabel"
        :label="$t('submission_status')"
      />

      <el-table-column :label="$t('actions')" align="left">
        <template slot-scope="scope">
          <div style="display: flex;align-items: center;gap: 10px;">
            <!-- 审核中 - 撤回 -->
            <el-tooltip :content="$t('revoke_submission')" placement="top" v-if="scope.row.articleEventType === 'DELIVERED'">
              <img class="icon-button" src="@/assets/icon-submission-revoke.png" style="width: 20px; height:20px;cursor: pointer;" @click="onRevoke(scope.row)">
            </el-tooltip>

            <!-- 初审通过需修稿 - 前往修改、查看反馈 -->
            <el-tooltip :content="$t('edit')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK_EDIT'">
              <img class="icon-button" src="@/assets/icon-submission-detail.png" style="width: 20px; height:20px;cursor: pointer;" @click="onEdit(scope.row)">
            </el-tooltip>
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK_EDIT'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 审核未通过 - 查看反馈 -->
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_NO'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 待复审 - 撤回、查看反馈 -->
            <el-tooltip :content="$t('revoke_submission')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK_EDITED'">
              <img class="icon-button" src="@/assets/icon-submission-revoke.png" style="width: 20px; height:20px;cursor: pointer;" @click="onRevoke(scope.row)">
            </el-tooltip>
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK_EDITED'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- DELIVERED2 -->
            <el-tooltip :content="$t('revoke_submission')" placement="top" v-if="scope.row.articleEventType === 'DELIVERED2'">
              <img class="icon-button" src="@/assets/icon-submission-revoke.png" style="width: 20px; height:20px;cursor: pointer;" @click="onRevoke(scope.row)">
            </el-tooltip>
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'DELIVERED2'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 审核通过 - 填写签约信息 查看反馈 -->
            <el-tooltip :content="$t('fill_sign_info')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK'">
              <img class="icon-button" src="@/assets/icon-fill-sign.png" style="width: 20px; height:20px;cursor: pointer;" @click="onSign(scope.row)">
            </el-tooltip>
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>
            <!-- <el-tooltip content="删除" placement="top" v-if="scope.row.articleEventType === 'CONTENT_OK'">
              <img class="icon-button" src="@/assets/icon-delete.png" style="width: 20px; height:20px;cursor: pointer;" @click="onDelete(scope.row)">
            </el-tooltip> -->

            <!-- 信息审核中 - 查看反馈 -->
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'SIGN_INFO_SUBMIT'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 信息未通过 - 修改签约信息、查看反馈 -->
            <el-tooltip :content="$t('edit_sign_info')" placement="top" v-if="scope.row.articleEventType === 'SIGN_INFO_AUDIT_NO'">
              <img class="icon-button" src="@/assets/icon-fill-sign.png" style="width: 20px; height:20px;cursor: pointer;" @click="onSignEdit(scope.row)">
            </el-tooltip>
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'SIGN_INFO_AUDIT_NO'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 待签约 - 查看反馈 -->
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'SIGN_INFO_AUDIT_OK'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 签约完成 - 查看反馈 -->
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'SIGN_OK'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 撤回投稿 - 重新投稿、删除、查看反馈 -->
            <el-tooltip :content="$t('resubmit')" placement="top" v-if="scope.row.articleEventType === 'RECALL'">
              <img class="icon-button" src="@/assets/icon-message.png" style="width: 20px; height:20px;cursor: pointer;" @click="onSubmission(scope.row)">
            </el-tooltip>
            <!-- <el-tooltip content="删除" placement="top" v-if="scope.row.articleEventType === 'RECALL'">
              <img class="icon-button" src="@/assets/icon-delete.png" style="width: 20px; height:20px;cursor: pointer;" @click="onDelete(scope.row)">
            </el-tooltip> -->
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'RECALL'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>

            <!-- 作废 - 查看反馈 -->
            <el-tooltip :content="$t('view_feedback')" placement="top" v-if="scope.row.articleEventType === 'INVALID'">
              <img class="icon-button" src="@/assets/icon-search.png" style="width: 20px; height:20px;cursor: pointer;" @click="onFeedback(scope.row)">
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <!-- empty -->
      <template v-slot:empty>
        <div class="data-empty" style="margin-top: 100px;">
          <img src="https://www.creatimix.com/static/empty.jpg" style="">
          <p style="margin-top: 20px;font-size: 18px;color: black;font-weight: 600;">{{ $t('no_submissions') }}</p>
          <p style="margin-top: 30px;color: rgba(0,0,0,0.6);font-size: 14px;">
            <!-- <el-button style="border-radius: 6px !important;padding: 0.5rem 2rem;margin-top: 1rem;margin-bottom: .5rem;" size="small" type="primary" @click="setShowLoginDialogFlag(true)">注册/登录</el-button> -->
            Start your journey!
          </p>
        </div>
      </template>
    </el-table>

    <el-row v-if="token != ''" class="pagination-fixed">
      <el-col>
        <div class="pagination">
          <el-pagination
            background
            hide-on-single-page
            :page-sizes="paginations.pages"
            :page-size="paginations.size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page.sync="paginations.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="dialogSelectSign"
      :show-close="true"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :title="$t('select_sign_info')"
      class="select-sign-dialog"
    >
      <div
        v-for="(item, index) in dialogSignList"
        :key="item.id"
        style="margin-bottom:10px;padding: 20px 24px; display: flex;align-items: center;gap: 20px;background: #F2F3FD;border-radius: 12px 12px 12px 12px;cursor: pointer;"
        :style="{ border: dialogSignSelectId === item.id ? 'solid 2px rgba(54, 110, 244, 1)' : '' }"
        @click="onSignSelect(item)"
      >
        <img :src="`https://maliwriter.com/static/avatar-${Math.min(index + 1, 5)}.png`" style="width: 40px; height:40px;cursor: pointer;">
        <div>
          <p>{{ item.name }}</p>
          <p>{{ item.phone }}</p>
        </div>
      </div>
      <div
        style="margin-bottom:10px;padding: 20px 24px; display: flex;align-items: center;gap: 20px;background: rgba(206, 208, 218, 0.19);border-radius: 12px 12px 12px 12px;cursor: pointer;"
        @click="$router.push('/account/sign')"
      >
        <img src="@/assets/icon-submissions-plus.png" style="width: 20px; height:20px;cursor: pointer;">
        <p>{{ $t('create_new_sign_info') }}</p>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px;">
        <el-button type="primary" size="small" @click="onSignNext">{{ $t('next_step') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="dialog-feedback"
      :visible.sync="dialogFeedback"
      :show-close="true"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :title="$t('view_feedback')"
    >
      <div class="feedback fail" v-for="item in dialogFeedbackList" :key="item.id">
        <div class="feedback-header">
          <span>{{item.updateTime}}</span>
        </div>
        <div class="feedback-content">
          <div v-html="item.objectText.split('\n').map(item => `<p>${item}</p>`).join('')"></div>
          <div style="display: flex;justify-content: flex-end;" v-if="item.predicateText === '审核通过'
          && item.article && item.article.articleEventType == 'CONTENT_OK'">
            <el-button type="primary" size="small" @click="dialogFeedback=false;onSign(dialogFeedbackData)">{{ $t('fill_sign_info') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState, mapMutations } from 'vuex'
import * as SubmissionsApi from '@/api/submissions'

export default {
  name: 'Submissions',
  components: {

  },
  data() {
    return {
      tableWidth: 0,
      sliderBoxActive: 0,
      showUpdateFlag: false,
      fromType: 'writer_client',
      intervalId: null,
      uploadFile: {},
      targetPermit: 'article',
      queryForm: {
        fromType: 'writer-web-delivery-page',
        id: '',
        title: '',
        current: 1,
        size: 20,
        articleEventType: ''
      },
      tableData: [],
      tableStat: {},
      progressMap: new Map(),
      activeMenuItem: 1,
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      },
      dialogSelectSign: false,
      dialogSignArticleId: '',
      dialogSignSelectId: '',
      dialogSignSelectData: null,
      dialogSignList: [],
      dialogFeedback: false,
      dialogFeedbackData: {},
      dialogFeedbackList: []
    }
  },
  computed: {
    ...mapState(['user', 'story', 'showDialogCdpFlag', 'enums',
      'showDialogDpFlag', 'showGenbyoutlineFlag', 'storyTiaojian', 'token'])
  },
  mounted() {
    this.$eventHub.$on('sign-continue', async() => {
      if (window.signDataCached) {
        await this.onSign(window.signDataCached)
        delete window.signDataCached
      }
    })
    if (window.submission_query_id) {
      this.queryForm.id = window.submission_query_id
      delete window.submission_query_id
    }
    this.$nextTick(() => {
      this.tableWidth = this.$refs.tableContainer.$el.offsetWidth
      console.log('tableWidth', this.tableWidth)
    })
    this.fetchList()
    console.log('articleEventType', JSON.stringify(this.enums.ArticleEventTypeEnum))
  },
  beforeDestroy() {
  },
  methods: {
    ...mapMutations(['setCurrentNotifyId', 'setActiveMenuItem', 'setStory']),
    goHome() {
      this.setActiveMenuItem('1')
      if (this.token === '') {
        this.$router.push('/')
      } else {
        this.$router.push('/home')
      }
    },

    async fetchList({ articleEventType = '' } = {}) {
      const { data } = await request({
        url: '/auth-service/articles/page',
        method: 'get',
        params: { ...this.queryForm, articleEventType, toUserId: this.user.id }
      })
      const result = data.data
      this.tableData = result.records
      this.tableStat = result.stat
      this.paginations.total = Number(result.total)
      this.paginations.current = Number(result.current)
      this.paginations.size = Number(result.size)
    },

    async fetchListByState(articleEventType = '') {
      this.queryForm.articleEventType = articleEventType
      this.fetchList({ articleEventType })
    },

    onDetail(row) {
      this.dialogReview = true
      this.diagloReviewData = row
    },
    async onSubmission(row) {
      await request({
        url: `/auth-service/articles/delivery/${row.id}`,
        method: 'post',
        data: {
          articleEventType: 'DELIVERED'
        }
      })
      this.$message.success(this.$t('resubmit_success'))
      this.fetchList()
    },
    onEdit(row) {
      this.setStory(row)
      setTimeout(() => {
        if (!row.stepNumber || row.stepNumber === 0 || row.stepNumber === 1) {
          if (this.story.articleGenType === 'GEN_BY_ZHIHU') {
            this.$router.push('/workspace/gen')
          } else if (this.story.articleGenType === 'GEN_BY_CHANGPIAN') {
            this.$router.push('/workspace/gencp')
          } else if (this.story.articleGenType === 'GEN_BY_IDEA') {
            this.$router.push('/workspace/genbyidea')
          } else if (this.story.articleGenType === 'GEN_BY_OUTLINE') {
            this.$router.push('/workspace/genbyoutline')
          }
        } else {
          if (this.story.articleGenType === 'GEN_BY_ZHIHU') {
            this.$router.push('/workspace/gen4')
          } else if (this.story.articleGenType === 'GEN_BY_CHANGPIAN') {
            this.$router.push('/workspace/gencp')
          } else if (this.story.articleGenType === 'GEN_BY_IDEA') {
            this.$router.push('/workspace/genbyidea3')
          } else if (this.story.articleGenType === 'GEN_BY_OUTLINE') {
            this.$router.push('/workspace/genbyoutline3')
          }
        }
      }, 300)
    },
    async onSign(row) {
      window.signDataCached = row
      const response = await request({
        url: '/auth-service/signinfos/page',
        method: 'get',
        params: { fromType: 'writer-web-delivery-page' }
      })
      const result = response.data.data
      if (result.records && result.records.length > 0) {
        this.dialogSelectSign = true
        this.dialogSignList = result.records
        this.dialogSignArticleId = row.id
        return
      }
      this.$router.push('/account/sign')
    },
    async onSignEdit(row) {
      this.$router.push(`/account/sign?id=${row.id}&signInfo=${row.signInfo}`)
      return
    },
    onSignSelect(item) {
      this.dialogSignSelectId = item.id
      this.$set(this, 'dialogSignSelectData', item)
    },
    async onSignNext() {
      if (!this.dialogSignSelectId) {
        return this.$message.warning(this.$t('please_select_sign_info'))
      }
      this.dialogSelectSign = false
      await request({
        url: `/auth-service/articles/submit_sign_info/${this.dialogSignArticleId}`,
        method: 'post',
        data: {
          ...this.dialogSignSelectData
        }
      })
      this.$message.success(this.$t('submit_success'))
      this.fetchList()
    },
    async onRevoke(row) {
      try {
        await this.$confirm(this.$t('confirm_revoke'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        })
        await request({
          url: `/auth-service/articles/recall/${row.id}`,
          method: 'post'
        })
        this.$message.success(this.$t('revoke_success'))
        this.fetchList()
      } catch (e) {
        console.log('error', e)
      }
    },
    async onFeedback(row) {
      const res = await SubmissionsApi.feedback(row.id)
      this.dialogFeedback = true
      this.$set(this, 'dialogFeedbackData', row)
      this.dialogFeedbackList = res.data.data.records
    },
    onDelete(row) {
      // 删除投稿逻辑
      this.$confirm(this.$t('confirm_delete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(async() => {
        try {
          await request({
            url: `/auth-service/articles/${row.id}?fromType=writer-web-rollback`,
            method: 'post'
          })
          this.$message.success(this.$t('delete_success'))
          this.fetchList()
        } catch (e) {
          console.log('error', e)
        }
      }).catch(() => {
        // 用户取消删除
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.queryForm.current = page
      this.fetchList()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.queryForm.size = size
      this.fetchList()
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-tooltip__popper {
  max-width: 200px;
}
.pagination-fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: -2rem;
  margin-right: 8px;
  background: #FAFAFD;
  padding: 1rem 0;
}
.custom-select {
    /deep/ .el-input__inner {
      border-radius: 20px;
      height: 1.5rem;
      line-height: 1.5rem;
      background-color: white;
      &:hover {
        background-color: white;
      }
    }
    /deep/ .el-input__suffix {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
}


/* 取消行悬停效果 */
/deep/ .el-table--enable-row-hover {
    background-color: transparent !important;
}

/* 取消行过渡效果 */
/deep/ .el-table--enable-row-transition {
    transition: none !important;
}
/deep/ .el-table th.el-table__cell.el-table__cell.is-leaf, /deep/ .el-table td.el-table__cell {
  border-bottom: none;
}
.table-container {
  margin-bottom: 1rem;
  /deep/ .el-table__body {
    border-spacing: 0 10px;
    border-radius: 20px;
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper.is-scrolling-left{
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper .el-table__empty-block {
    width: auto !important;
  }
}

::v-deep .el-table td:first-child {
  border-radius: 20px 0 0 20px;
  padding-left: 2rem;
}
::v-deep .el-table td:last-child {
  border-radius: 0 20px 20px 0;
}

::v-deep td.el-table__cell {
  color: rgba(0,0,0,0.8);
  background-color: transparent !important;
}
::v-deep .el-table .el-table__cell:first-child {
  padding-left: 2rem;
}
::v-deep .el-table__row:hover{
  background-color: #E5E7FC !important;
}
::v-deep .el-table__row {
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.8);
}
.max-width-column .cell {
  max-width: 15rem; /* 设置最大宽度 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.data-empty {
  padding: 1rem;
  height: calc( 100vh - 8rem );
}
/deep/ .el-empty {

}
/deep/ .el-empty__bottom {
  margin-top: 10px;
}
/deep/ .el-table__empty-text {
  line-height: 0px !important;
}
.search-title {
  /deep/ .el-input__inner {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
  }
  /deep/ .el-input__suffix {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
  /* CSS样式 */
.image-switcher {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-size: cover;
  transition: background-image 0.3s; /* 平滑过渡效果 */
  &-sousuo-hui {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }
  &-sousuo {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }
  &-sousuo:hover {
    background-image: url('../../assets/icon-sousuo-1.png'); /* 默认状态下的图片 */
  }
  &-sousuo:active {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }

  &-edit {
    background-image: url('../../assets/icon-edit.png'); /* 默认状态下的图片 */
  }
  &-edit:hover {
    background-image: url('../../assets/icon-edit-1.png'); /* 默认状态下的图片 */
  }
  &-edit:active {
    background-image: url('../../assets/icon-edit.png'); /* 默认状态下的图片 */
  }

  &-chaishu {
    background-image: url('../../assets/icon-chaishu.png'); /* 默认状态下的图片 */
  }
  &-chaishu:hover {
    background-image: url('../../assets/icon-chaishu-1.png'); /* 默认状态下的图片 */
  }
  &-chaishu:active {
    background-image: url('../../assets/icon-chaishu.png'); /* 默认状态下的图片 */
  }

  &-delete {
    background-image: url('../../assets/icon-delete.png'); /* 默认状态下的图片 */
  }
  &-delete:hover {
    background-image: url('../../assets/icon-delete-1.png'); /* 默认状态下的图片 */
  }
  &-delete:active {
    background-image: url('../../assets/icon-delete.png'); /* 默认状态下的图片 */
  }
}
.single-line-content {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.select-sign-dialog /deep/ .el-dialog {
  border-radius: 20px!important;
  overflow: hidden;
}
.button-active {
  color: #0052D9;
  border-color: #b3cbf4;
  background-color: #e6eefb;
}

.feedback {
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
  padding-top: 0;
}

.feedback-header {
  color: rgba(0, 0, 0, 0.50);
  margin-bottom: 8px;
}
.feedback-content {
  background: rgba(229,231,252,0.5);
  border-radius: 0.63rem 0.63rem 0.63rem 0.63rem;
  margin-top: 4px;
  padding: 16px 20px;
  line-height: 2;
}

.icon-button {
  opacity: 0.5;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}

::v-deep .el-table__header-wrapper thead tr,
::v-deep .el-table__header .el-table__cell {
  background: transparent !important;
  > .has-gutter tr {
    background: transparent !important;
  }
  > th.el-table__cell {
    background: transparent !important;
  }
}

::v-deep .el-table__header-wrapper th.el-table__cell > .cell,
::v-deep .el-table__row .el-table__cell > .cell {
  padding: 0!important;
}

::v-deep .el-table::before {
  height: 0!important;
}

::v-deep .el-dialog {
  border-radius: 20px!important;
  overflow: hidden;
}

::v-deep .el-table {
  // padding: 0 16px!important;
  &::before {
    height: 0!important;
  }
  th, td {
    padding: 0!important;
    box-sizing: content-box!important;
    border-top: 0!important;
  }

  .el-table__header .el-table__cell .cell,
  .el-table__row .el-table__cell .cell {
    padding-left: 0!important;
    padding-right: 0!important;
  }

  @media (max-width: 768px) {
    .el-table__header .el-table__cell .cell,
    .el-table__row .el-table__cell .cell {
      padding-left: 8px!important;
      padding-right: 8px!important;
    }
  }
}
</style>
